import React from 'react';

import type { AiImageModalState } from './slice/types';

type UseAiImageModalShortcutsProps = {
  state: AiImageModalState;
  modalRef: HTMLDivElement | null;
  cancelPrompt: () => void;
  closeModal: () => void;
};

export const useAiImageModalShortcuts = ({
  state,
  modalRef,
  cancelPrompt,
  closeModal,
}: UseAiImageModalShortcutsProps) => {
  React.useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }

    const handleKeyDown = (e: KeyboardEvent) => {
      if (!(modalRef?.contains(document.activeElement) || modalRef === document.activeElement)) {
        return;
      }

      switch (state.type) {
        case 'IN_PROGRESS': {
          if (e.key === 'Escape') {
            cancelPrompt();
            return;
          }

          break;
        }
        default: {
          // nothing to do here
        }
      }

      if (e.key === 'Escape') {
        closeModal();
        return;
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [modalRef, state, closeModal]);
};
